module.exports = __webpack_public_path__ + "img/tommy-full.c82320fa.webp";